import {Modal} from "react-bootstrap";

import {Button} from "@/components/button/Button.tsx";

import {NetworkProbePanels} from "./NetworkProbePanels.tsx";
import {NetworkProbeModalProps} from "./networkRunTestTypes.ts";

export const NetworkProbeModal = ({
  show,
  title,
  probes,
  context,
  onClose,
  initialIndex = 0,
}: NetworkProbeModalProps) => (
  <Modal show={show} onHide={onClose} size="xl" centered>
    <Modal.Header closeButton>
      <Modal.Title className="pulseTextH2Bold">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0">
      <NetworkProbePanels probes={probes} context={context} initialIndex={initialIndex} />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={onClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);
